import React, { Component } from "react";
import httpService from "../../services/httpService";
import config from "../../config.json";
import authService from "../../services/authService";
import { Button, Spinner } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { ButtonGroup } from "react-bootstrap";
import HledatOsobu from "../common/HledatOsobu";

class Uzivatele extends Component {
  state = {
    novyLoginData: {},
    stranka: parseInt(1),
    kolektiv: [
      "gastronomie - pohostinství",
      "kolektiv výroba",
      "kolektiv kancelář",
    ],
  };
  fulltextTimer = false;

  componentDidMount = () => {
    this.nahrajUzivatele();
    this.nahrajPojistovny();
  };

  nahrajPojistovny = async () => {
    const pojistovny = await httpService.post(
      config.apiEndpoint + "covid/zdravotniPojistovny.php"
    );
    this.setState({ pojistovny: pojistovny.data.pojistovny });
  };

  nahrajUzivatele = async (forceStranka, srch) => {
    const user = authService.getCurrentUser();
    let { stranka } = this.state;
    stranka = parseInt(forceStranka ? forceStranka : stranka);
    //srch = forceSrch ? forceSrch : srch;
    if (user.admin === "1") {
      const uzivatele = await httpService.post(
        config.apiEndpoint + "uzivatele/vypis.php",
        { stranka, srch }
      );
      this.setState({
        uzivatele: uzivatele.data.uzivatele,
        zamestnavatele: uzivatele.data.zamestnavatele,
        systemizace: uzivatele.data.systemizace,
        pracoviste: uzivatele.data.pracoviste,
        vakcina: uzivatele.data.vakcina,
        duvodNepritomnosti: uzivatele.data.duvodNepritomnosti,
        loaded: true,
        pocetStranek: uzivatele.data.pocet,
        stranka,
        srch,
      });
    } else {
      alert("Access denied");
    }
  };

  closeModal = () => {
    this.setState({ user: null });
  };

  userChangeDetail = (login, attr, val, save) => {
    let { user } = this.state;
    if (user) {
      user[attr] = val;
    }
    console.log("save", save, attr, val, user);
    this.setState({ user });
    if (save === true) {
      let { uzivatele } = this.state;
      uzivatele.find((u) => u.login === login)[attr] = val;
      this.setState({ uzivatele });
      httpService.post(config.apiEndpoint + "uzivatele/zmenaDetail.php", {
        login,
        attr,
        val,
      });
    }
  };

  novyLogin = async () => {
    const { novyLoginData } = this.state;
    const response = await httpService.post(
      config.apiEndpoint + "uzivatele/novyUzivatel.php",
      { novyLoginData }
    );
    if (response.data.error) {
      toast.error(response.data.error);
    } else {
      this.nahrajUzivatele();
      this.setState({ novyLoginData: {}, novyLogin: false });
      toast.success("Nový uživatel založen");
    }
  };

  delUser = async (confirmed) => {
    const { user } = this.state;
    if (confirmed === true) {
      await httpService.post(
        config.apiEndpoint + "uzivatele/smazatUzivatele.php",
        { login: user.login }
      );
      let { uzivatele } = this.state;
      uzivatele = uzivatele.filter((u) => u.login !== user.login);
      this.setState({ user: null, uzivatele });
    } else {
      if (window.confirm("Skutečně smazat uživatele " + user.login + "?")) {
        this.delUser(true);
      }
    }
  };

  fulltext = (srch) => {
    let { fulltext } = this.state;
    fulltext = srch;
    this.setState({ fulltext });
    if (fulltext.toString().length === 0 || fulltext.toString().length > 3) {
      console.log("fulltext", fulltext);
    }
    if (this.fulltextTimer) {
      clearTimeout(this.fulltextTimer);
    }
    this.fulltextTimer = setTimeout(() => this.nahrajUzivatele(1, srch), 500);
  };

  sendPassSMS = async () => {
    let { user } = this.state;
    user.smsSent = true;
    this.setState({ user });
    await httpService.post(
      config.apiEndpoint + "uzivatele/poslatHesloSMS.php",
      { login: user.login }
    );
    toast.success("Heslo bylo odesláno");
  };

  novaDavka = async () => {
    const { datum, vakcina_id } = this.state;
    let { user, uzivatele } = this.state;
    user.ockovani.push({ datum, vakcina_id });
    this.setState({ user, datum: null });
    await httpService.post(config.apiEndpoint + "covid/novaDavka.php", {
      login: user.login,
      datum,
      vakcina_id,
    });
    uzivatele.find((u) => u.login === user.login).ockovani = user.ockovani;
    this.setState({ uzivatele });
  };

  zmenaVakcinace = async (login, datum, attr, val) => {
    let { user, uzivatele } = this.state;
    if (attr === "del") {
      if (val === true) {
        user.ockovani = user.ockovani.filter((o) => o.datum !== datum);
      } else {
        if (window.confirm("Urcite smazat?")) {
          this.zmenaVakcinace(login, datum, attr, true);
        }
        return false;
      }
    } else {
      user.ockovani.find((o) => o.datum === datum)[attr] = val;
    }
    this.setState({ user });
    await httpService.post(config.apiEndpoint + "covid/zmenaVakcinace.php", {
      login,
      datum,
      attr,
      val,
    });
    uzivatele.find((u) => u.login === user.login).ockovani = user.ockovani;
    this.setState({ uzivatele });
  };

  render() {
    const {
      uzivatele,
      loaded,
      user,
      novyLogin,
      novyLoginData,
      stranka,
      pocetStranek,
      fulltext,
      zamestnavatele,
      systemizace,
      pracoviste,
      vakcina,
      duvodNepritomnosti,
      pojistovny,
      kolektiv,
      datum,
      vakcina_id,
    } = this.state;
    let stranky = [];
    if (stranka && pocetStranek && loaded) {
      for (let i = 0; i < pocetStranek; i++) {
        stranky.push(i + 1);
      }
    }
    return (
      <React.Fragment>
        {loaded ? (
          <React.Fragment>
            <Modal
              show={user}
              onHide={this.closeModal}
              dialogClassName="modal-90w"
            >
              <Modal.Header closeButton>Editace uživatele</Modal.Header>
              <Modal.Body>
                {user && (
                  <React.Fragment>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-4">
                            <small>Jméno</small>
                            <input
                              className="form-control"
                              type="text"
                              name="jmeno"
                              value={user.jmeno}
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  false
                                )
                              }
                              onBlur={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          </div>
                          <div className="col-md-4">
                            <HledatOsobu
                              value={user.nadrizenyJmeno}
                              title="Nadřízený"
                              onSelect={(login, jmeno) => {
                                this.userChangeDetail(
                                  user.login,
                                  "nadrizenyLogin",
                                  login,
                                  true
                                );
                                this.userChangeDetail(
                                  user.login,
                                  "nadrizenyJmeno",
                                  jmeno,
                                  true
                                );
                              }}
                            />
                          </div>
                          <div className="col-md-4">
                            <small>Zaměstnavatel/Místo</small>
                            <select
                              name="firma_id"
                              value={user.firma_id}
                              className="form-control"
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            >
                              <option value="">Nezařazen</option>
                              {zamestnavatele &&
                                zamestnavatele.length > 0 &&
                                zamestnavatele.map((f) => (
                                  <option value={f.firma_id} key={f.firma_id}>
                                    {f.nazev}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div className="col-md-4">
                            <small>Mobil (bez mezer vč. +420)</small>
                            <input
                              className="form-control"
                              type="text"
                              name="mobil"
                              value={user.mobil}
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  false
                                )
                              }
                              onBlur={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          </div>
                          <div className="col-md-5">
                            <small>Heslo (změna)</small>
                            <input
                              className="form-control"
                              type="text"
                              name="pass"
                              value={user.pass}
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  false
                                )
                              }
                              onBlur={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          </div>
                          <div
                            className="col-md-3"
                            style={{ paddingTop: "25px" }}
                          >
                            <Button
                              disabled={user.smsSent}
                              onClick={this.sendPassSMS}
                            >
                              Přes SMS
                            </Button>
                          </div>
                          <div className="col-md-4">
                            <small>Pracoviště</small>
                            <select
                              name="cisloPrac"
                              value={user.cisloPrac}
                              className="form-control"
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            >
                              <option value="0">Nezařazen</option>
                              {pracoviste &&
                                pracoviste.map((p) => (
                                  <option value={p.cisloPrac} key={p.cisloPrac}>
                                    {p.nazev}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div className="col-md-4">
                            <small>Systemizace</small>
                            <select
                              name="systemizace"
                              value={user.systemizace}
                              className="form-control"
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            >
                              <option value="0">Nezařazen</option>
                              {systemizace &&
                                systemizace.map((p) => (
                                  <option
                                    value={p.systemizace}
                                    key={p.systemizace}
                                  >
                                    {p.nazev}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div className="col-md-4">
                            <small>Rodné číslo</small>
                            <input
                              className="form-control"
                              type="text"
                              name="rodneCislo"
                              value={user.rodneCislo}
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  false
                                )
                              }
                              onBlur={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          </div>
                          <div className="col-md-4">
                            <small>Datum narození</small>
                            <input
                              className="form-control"
                              type="date"
                              name="datumNarozeni"
                              value={user.datumNarozeni}
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  false
                                )
                              }
                              onBlur={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          </div>
                          <div className="col-md-4">
                            <small>Cizinecké číslo</small>
                            <input
                              className="form-control"
                              type="text"
                              name="cizineckeCislo"
                              value={user.cizineckeCislo}
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  false
                                )
                              }
                              onBlur={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          </div>
                          <div className="col-md-4">
                            <small>Kolektiv</small>
                            <select
                              value={user.kolektiv}
                              className="form-control"
                              name="kolektiv"
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            >
                              <option value="">Neuveden</option>
                              {kolektiv.map((k) => (
                                <option value={k} key={k}>
                                  {k}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <small>Zdravotní pojišťovna</small>
                            <select
                              name="zdravotniPojistovna"
                              className="form-control"
                              value={user.zdravotniPojistovna}
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            >
                              <option value="">Pojištovna nenastavena</option>
                              {pojistovny &&
                                pojistovny.map((p) => (
                                  <option value={p.pojistovna_id}>
                                    {p.pojistovna_id} - {p.nazev}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <small>Nepřítomnost</small>
                            <select
                              name="nepritomen"
                              className="form-control"
                              value={user.nepritomen}
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            >
                              {duvodNepritomnosti &&
                                duvodNepritomnosti.map((d) => (
                                  <option value={d.duvod_id} key={d.duvod_id}>
                                    {d.nazev}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <small>Ulice</small>
                            <input
                              className="form-control"
                              type="text"
                              name="ulice"
                              value={user.ulice}
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  false
                                )
                              }
                              onBlur={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <small>Město</small>
                            <input
                              className="form-control"
                              type="text"
                              name="mesto"
                              value={user.mesto}
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  false
                                )
                              }
                              onBlur={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <small>PSČ</small>
                            <input
                              className="form-control"
                              type="text"
                              name="psc"
                              value={user.psc}
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  false
                                )
                              }
                              onBlur={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <small>Státní příslušnost</small>
                            <input
                              className="form-control"
                              type="text"
                              name="statniPrislusnost"
                              value={user.statniPrislusnost}
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  false
                                )
                              }
                              onBlur={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          </div>
                          <div className="col-md-4">
                            <small>Ukončení prac. poměru</small>
                            <input
                              type="date"
                              name="ukonceniPomeru"
                              className="form-control"
                              value={user.ukonceniPomeru}
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  false
                                )
                              }
                              onBlur={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          </div>
                          <div className="col-md-4">
                            <small>Covid pozitivní</small>
                            <input
                              type="date"
                              name="covidPozitivni"
                              className="form-control"
                              value={user.covidPozitivni}
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  false
                                )
                              }
                              onBlur={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          </div>
                          <div className="col-md-4">
                            <small>GDPR souhlas</small>
                            <input
                              type="date"
                              name="gdprSouhlas"
                              className="form-control"
                              value={user.gdprSouhlas}
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  false
                                )
                              }
                              onBlur={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          </div>
                          <div className="col-md-12">
                            <small>Filtr provozů</small>
                            <input
                              type="text"
                              name="filtrProvozu"
                              className="form-control"
                              value={user.filtrProvozu}
                              onChange={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  false
                                )
                              }
                              onBlur={(e) =>
                                this.userChangeDetail(
                                  user.login,
                                  e.target.name,
                                  e.target.value,
                                  true
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <h4>Vakcinace</h4>
                        <div className="row">
                          {user.ockovani &&
                            user.ockovani.map((o) => (
                              <div
                                className="col-md-12"
                                key={o.datum}
                                style={{
                                  borderTop: "solid 1px #ddd",
                                  paddingTop: "10px",
                                  paddingBottom: "10px",
                                }}
                              >
                                <div className="row">
                                  <div className="col-5">
                                    <small>Datum</small>
                                    <input
                                      type="date"
                                      className="form-control"
                                      name="datum"
                                      value={o.datum}
                                      onChange={(e) =>
                                        this.zmenaVakcinace(
                                          user.login,
                                          o.datum,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                  <div className="col-5">
                                    <small>Vakcína</small>
                                    <select
                                      name="vakcina_id"
                                      className="form-control"
                                      value={o.vakcina_id}
                                      onChange={(e) =>
                                        this.zmenaVakcinace(
                                          user.login,
                                          o.datum,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    >
                                      {vakcina &&
                                        vakcina.map((v) => (
                                          <option
                                            value={v.vakcina_id}
                                            key={v.vakcina_id}
                                          >
                                            {v.nazev}, {v.vyrobce}
                                          </option>
                                        ))}
                                    </select>
                                  </div>
                                  <div className="col-2">
                                    <button
                                      className="btn btn-danger"
                                      style={{ marginTop: "20px" }}
                                      onClick={() =>
                                        this.zmenaVakcinace(
                                          user.login,
                                          o.datum,
                                          "del",
                                          false
                                        )
                                      }
                                    >
                                      DEL
                                    </button>
                                  </div>
                                  {o.upravil_jmeno && o.upravil_jmeno !== "" && (
                                    <div className="col-12">
                                      <small>
                                        {o.upravil_jmeno} | {o.upravil_datum}
                                      </small>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}
                          <div
                            className="col-md-12"
                            style={{
                              borderTop: "solid 1px #ddd",
                              paddingTop: "10px",
                              paddingBottom: "10px",
                            }}
                          >
                            <div className="row">
                              <div className="col-5">
                                <small>Nové datum vakcinace</small>
                                <input
                                  type="date"
                                  className="form-control"
                                  name="datum"
                                  value={datum}
                                  onChange={(e) =>
                                    this.setState({
                                      [e.target.name]: e.target.value,
                                    })
                                  }
                                />
                              </div>
                              <div className="col-5">
                                <small>Vakcína</small>
                                <select
                                  name="vakcina_id"
                                  className="form-control"
                                  value={vakcina_id}
                                  onChange={(e) =>
                                    this.setState({
                                      [e.target.name]: e.target.value,
                                    })
                                  }
                                >
                                  {vakcina &&
                                    vakcina.map((v) => (
                                      <option
                                        value={v.vakcina_id}
                                        key={v.vakcina_id}
                                      >
                                        {v.nazev}, {v.vyrobce}
                                      </option>
                                    ))}
                                </select>
                              </div>
                              <div className="col-2">
                                <button
                                  className="btn btn-success"
                                  style={{ marginTop: "20px" }}
                                  disabled={!datum}
                                  onClick={this.novaDavka}
                                >
                                  Přidat
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="danger" onClick={this.delUser}>
                  Smazat uživatele
                </Button>
                <Button variant="info" onClick={this.closeModal}>
                  Storno
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal
              show={novyLogin}
              onHide={() => this.setState({ novyLogin: false })}
            >
              <Modal.Header closeButton>Nový login</Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-md-6">
                    <small>Login</small>
                    <input
                      type="text"
                      className="form-control"
                      value={novyLoginData.login}
                      name="login"
                      onChange={(e) =>
                        this.setState({
                          novyLoginData: {
                            ...novyLoginData,
                            [e.target.name]: e.target.value,
                            pass:
                              parseInt(e.target.value).toString(16) + "1883",
                          },
                        })
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <small>Jméno</small>
                    <input
                      type="text"
                      className="form-control"
                      value={novyLoginData.jmeno}
                      name="jmeno"
                      onChange={(e) =>
                        this.setState({
                          novyLoginData: {
                            ...novyLoginData,
                            [e.target.name]: e.target.value,
                          },
                        })
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <small>Heslo</small>
                    <input
                      type="text"
                      className="form-control"
                      value={novyLoginData.pass}
                      name="pass"
                      onChange={(e) =>
                        this.setState({
                          novyLoginData: {
                            ...novyLoginData,
                            [e.target.name]: e.target.value,
                          },
                        })
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <small>Mobil</small>
                    <input
                      type="text"
                      className="form-control"
                      value={novyLoginData.mobil}
                      name="mobil"
                      onChange={(e) =>
                        this.setState({
                          novyLoginData: {
                            ...novyLoginData,
                            [e.target.name]: e.target.value,
                          },
                        })
                      }
                    />
                  </div>
                  <div className="col-md-12">
                    <small>Zaměstnavatel/Místo</small>
                    <select
                      name="firma_id"
                      value={novyLoginData.firma_id}
                      className="form-control"
                      onChange={(e) =>
                        this.setState({
                          novyLoginData: {
                            ...novyLoginData,
                            [e.target.name]: e.target.value,
                          },
                        })
                      }
                    >
                      <option value="0">Nezařazen</option>
                      {zamestnavatele &&
                        zamestnavatele.map((p) => (
                          <option value={p.firma_id} key={p.firma_id}>
                            {p.nazev}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <small>Pracoviště</small>
                    <select
                      name="cisloPrac"
                      value={novyLoginData.cisloPrac}
                      className="form-control"
                      onChange={(e) =>
                        this.setState({
                          novyLoginData: {
                            ...novyLoginData,
                            [e.target.name]: e.target.value,
                          },
                        })
                      }
                    >
                      <option value="0">Nezařazen</option>
                      {pracoviste &&
                        pracoviste.map((p) => (
                          <option value={p.cisloPrac} key={p.cisloPrac}>
                            {p.nazev}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <small>Systemizace</small>
                    <select
                      name="systemizace"
                      value={novyLoginData.systemizace}
                      className="form-control"
                      onChange={(e) =>
                        this.setState({
                          novyLoginData: {
                            ...novyLoginData,
                            [e.target.name]: e.target.value,
                          },
                        })
                      }
                    >
                      <option value="0">Nezařazen</option>
                      {systemizace &&
                        systemizace.map((p) => (
                          <option value={p.systemizace} key={p.systemizace}>
                            {p.nazev}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <small>Je admin</small>
                    <div>
                      <input
                        type="checkbox"
                        name="admin"
                        checked={novyLoginData.admin === "1"}
                        onChange={(e) =>
                          this.setState({
                            novyLoginData: {
                              ...novyLoginData,
                              [e.target.name]: e.target.checked ? "1" : "0",
                            },
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <small>E-recept</small>
                    <div>
                      <input
                        type="checkbox"
                        name="erecept"
                        checked={novyLoginData.erecept === "1"}
                        onChange={(e) =>
                          this.setState({
                            novyLoginData: {
                              ...novyLoginData,
                              [e.target.name]: e.target.checked ? "1" : "0",
                            },
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <small>Časování</small>
                    <div>
                      <input
                        type="checkbox"
                        name="casovani"
                        checked={novyLoginData.casovani === "1"}
                        onChange={(e) =>
                          this.setState({
                            novyLoginData: {
                              ...novyLoginData,
                              [e.target.name]: e.target.checked ? "1" : "0",
                            },
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <small>Housekeeping</small>
                    <div>
                      <input
                        type="checkbox"
                        name="housekeeping"
                        checked={novyLoginData.housekeeping === "1"}
                        onChange={(e) =>
                          this.setState({
                            novyLoginData: {
                              ...novyLoginData,
                              [e.target.name]: e.target.checked ? "1" : "0",
                            },
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <small>Covid Admin</small>
                    <div>
                      <input
                        type="checkbox"
                        name="covidAdmin"
                        checked={novyLoginData.covidAdmin === "1"}
                        onChange={(e) =>
                          this.setState({
                            novyLoginData: {
                              ...novyLoginData,
                              [e.target.name]: e.target.checked ? "1" : "0",
                            },
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={this.novyLogin}>Vytvořit</Button>
                <Button
                  variant="info"
                  onClick={() => this.setState({ novyLogin: false })}
                >
                  Storno
                </Button>
              </Modal.Footer>
            </Modal>
            <div style={{ paddingBottom: "20px" }}>
              <div className="row">
                <div className="col-md-2">
                  <Button onClick={() => this.setState({ novyLogin: true })}>
                    Nový login
                  </Button>
                </div>
                <div className="col-md-10">
                  <input
                    type="text"
                    value={fulltext}
                    className="form-control"
                    placeholder="Hledat osobu"
                    onChange={(e) => this.fulltext(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <table class="table">
              <thead>
                <tr>
                  <th>Login</th>
                  <th>Jméno</th>
                  <th>Je admin?</th>
                  {config.lazne && <th>E-recept</th>}
                  {config.lazne && <th>Časování</th>}
                  {config.lazne && <th>Housekeeping</th>}
                  <th>Novinky</th>
                  <th>Covid Admin</th>
                  <th></th>
                </tr>
                {uzivatele &&
                  uzivatele.length > 0 &&
                  uzivatele.map((u) => (
                    <tr key={u.login}>
                      <td>{u.login}</td>
                      <td>
                        {u.jmeno}
                        <br />
                        <small>{u.mobil}</small>
                      </td>
                      <td className="text-center" title="Je admin?">
                        <input
                          type="checkbox"
                          value={1}
                          checked={u.admin === "1"}
                          name="admin"
                          onChange={(e) =>
                            this.userChangeDetail(
                              u.login,
                              e.target.name,
                              e.target.checked ? "1" : "0",
                              true
                            )
                          }
                        />
                      </td>
                      {config.lazne && (
                        <td className="text-center" title="E-recept">
                          <input
                            type="checkbox"
                            value={1}
                            checked={u.erecept === "1"}
                            name="erecept"
                            onChange={(e) =>
                              this.userChangeDetail(
                                u.login,
                                e.target.name,
                                e.target.checked ? "1" : "0",
                                true
                              )
                            }
                          />
                        </td>
                      )}
                      {config.lazne && (
                        <td className="text-center" title="Časování">
                          <input
                            type="checkbox"
                            value={1}
                            checked={u.casovani === "1"}
                            name="casovani"
                            onChange={(e) =>
                              this.userChangeDetail(
                                u.login,
                                e.target.name,
                                e.target.checked ? "1" : "0",
                                true
                              )
                            }
                          />
                        </td>
                      )}
                      {config.lazne && (
                        <td className="text-center" title="Housekeeping">
                          <input
                            type="checkbox"
                            value={1}
                            checked={u.housekeeping === "1"}
                            name="housekeeping"
                            onChange={(e) =>
                              this.userChangeDetail(
                                u.login,
                                e.target.name,
                                e.target.checked ? "1" : "0",
                                true
                              )
                            }
                          />
                        </td>
                      )}
                      <td className="text-center" title="Covid Admin">
                        <input
                          type="checkbox"
                          value={1}
                          checked={u.covidAdmin === "1"}
                          name="covidAdmin"
                          onChange={(e) =>
                            this.userChangeDetail(
                              u.login,
                              e.target.name,
                              e.target.checked ? "1" : "0",
                              true
                            )
                          }
                        />
                      </td>
                      <td className="text-center" title="Novinky">
                        <input
                          type="checkbox"
                          value={1}
                          checked={u.novinky === "1"}
                          name="novinky"
                          onChange={(e) =>
                            this.userChangeDetail(
                              u.login,
                              e.target.name,
                              e.target.checked ? "1" : "0",
                              true
                            )
                          }
                        />
                      </td>
                      <td>
                        <Button
                          variant="primary"
                          onClick={() =>
                            this.setState({
                              user: JSON.parse(JSON.stringify(u)),
                            })
                          }
                        >
                          Další nastavení
                        </Button>
                      </td>
                    </tr>
                  ))}
              </thead>
            </table>
            <div style={{ paddingTop: "10px", paddingBottom: "20px" }}>
              <ButtonGroup>
                <Button
                  disabled={stranka === 1}
                  onClick={() => this.nahrajUzivatele(stranka - 1)}
                >
                  &lt;
                </Button>
                <select
                  value={stranka}
                  onChange={(e) => this.nahrajUzivatele(e.target.value)}
                >
                  {stranky && stranky.map((s) => <option key={s}>{s}</option>)}
                </select>
                <Button
                  disabled={stranka === pocetStranek}
                  onClick={() => this.nahrajUzivatele(stranka + 1)}
                >
                  &gt;
                </Button>
              </ButtonGroup>
            </div>
          </React.Fragment>
        ) : (
          <div className="text-warning">
            <Spinner animation="grow" size="sm" variant="warning" />
            Loading...
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default Uzivatele;
